// Discovery-BYO Cart Guard + Visual Grouping
// ============================================
// Bundle-Lines (Property `_bundle: lyora-discovery-byo`) sind atomar.
// Jeder ATC-Click vom Builder vergibt eine `_bundle_group` ID, damit
// mehrere Sets im Cart unterschieden werden können. Eine Gruppe besteht
// aus der Box (Produkt lyora-discovery-set, trägt den Set-Preis) plus
// 4 Duftproben (von der Discount-Function auf 0 € gesetzt). Legacy-Carts
// von vor dieser Änderung haben nur die 4 Proben.
//
// 1) Auto-Cleanup: bei Teil-Bundle (Proben ≠ 4 × Boxen, bzw. ohne Box
//    Proben % 4 != 0) fliegen alle Lines dieser Gruppe raus — sonst zahlt
//    der Customer Vollpreis für den Rest, die Discount-Function greift nur
//    bei kompletten Sets.
// 2) Visuelle Gruppierung: jede Gruppe wird im Cart-Drawer als eine Zeile
//    dargestellt. Head = die Box-Line (eigener Titel, Bild, Preis), die
//    Proben-Lines werden versteckt und als Liste unter dem Head gezeigt.
//    Ohne Box (Legacy) wird die erste Proben-Line zum Head umgeschrieben.
//    X auf der Gruppe entfernt nur diese Gruppe.

(function () {
  const BUNDLE_SLUG = 'lyora-discovery-byo';
  const BUNDLE_SIZE = 4;
  const BUNDLE_PRICE_DISPLAY = '€29,99';
  const BUNDLE_PARENT_HANDLE = 'lyora-discovery-set';
  const BUNDLE_PARENT_URL = '/products/' + BUNDLE_PARENT_HANDLE;
  const BOX_SKU = 'BYO-DISCOVERY-SET';
  const LEGACY_GROUP = '__legacy';

  function isBoxItem(item) {
    return item.handle === BUNDLE_PARENT_HANDLE || item.sku === BOX_SKU;
  }

  // A group is complete when the samples match the boxes (4 per box), or –
  // legacy without box – when the sample quantity is a multiple of 4.
  function groupShape(groupEntries) {
    let boxQty = 0;
    let sampleQty = 0;
    const boxes = [];
    const samples = [];
    for (const e of groupEntries) {
      if (isBoxItem(e.item)) { boxQty += e.item.quantity; boxes.push(e); }
      else { sampleQty += e.item.quantity; samples.push(e); }
    }
    const complete = boxQty > 0
      ? sampleQty === boxQty * BUNDLE_SIZE
      : sampleQty > 0 && sampleQty % BUNDLE_SIZE === 0;
    return { boxQty, sampleQty, boxes, samples, complete };
  }
  let isCleaning = false;
  let bundleImageUrl = null;

  function getBundleEntries(cart) {
    const items = cart.items || [];
    const out = [];
    for (let i = 0; i < items.length; i++) {
      if (items[i].properties && items[i].properties._bundle === BUNDLE_SLUG) {
        out.push({ item: items[i], index: i });
      }
    }
    return out;
  }

  // Bucket bundle entries by `_bundle_group` property. Lines without a
  // group ID (legacy carts from before this change) fall into one bucket
  // so they still render as a single set instead of breaking.
  function bucketByGroup(entries) {
    const buckets = new Map();
    for (const entry of entries) {
      const gid = entry.item.properties._bundle_group || LEGACY_GROUP;
      if (!buckets.has(gid)) buckets.set(gid, []);
      buckets.get(gid).push(entry);
    }
    return buckets;
  }

  function findCartItemElement(itemIndex) {
    const id1 = itemIndex + 1;
    return (
      document.getElementById('CartItem-' + id1) ||
      document.getElementById('CartDrawer-Item-' + id1)
    );
  }

  function collectSectionsToRefresh() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', {
        bubbles: true,
        detail: { sections },
      })
    );
    return sections;
  }

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function fetchBundleParentImage() {
    try {
      const r = await fetch(BUNDLE_PARENT_URL + '.js', {
        headers: { Accept: 'application/json' },
      });
      const p = await r.json();
      const url = p.featured_image || (p.images && p.images[0]) || null;
      if (url) bundleImageUrl = url.startsWith('//') ? 'https:' + url : url;
    } catch (e) {
      /* non-fatal: header keeps the first sample image */
    }
  }

  async function removeItems(items) {
    if (isCleaning) return null;
    isCleaning = true;
    try {
      const updates = {};
      items.forEach((i) => {
        updates[i.key] = 0;
      });
      const sections = collectSectionsToRefresh();
      const resp = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates,
          sections: sections.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const state = await resp.json();
      if (window.FoxTheme && FoxTheme.pubsub) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'discovery-byo-guard',
          cart: state,
        });
      }
      return state;
    } finally {
      isCleaning = false;
    }
  }

  // Per-group cleanup: if any group has qty % 4 != 0, wipe that group.
  // Other groups (complete sets) are left alone.
  async function cleanupOrphans(cart) {
    const entries = getBundleEntries(cart);
    if (entries.length === 0) return false;

    const buckets = bucketByGroup(entries);
    const itemsToRemove = [];
    for (const groupEntries of buckets.values()) {
      if (!groupShape(groupEntries).complete) {
        itemsToRemove.push(...groupEntries.map((e) => e.item));
      }
    }
    if (itemsToRemove.length === 0) return false;
    await removeItems(itemsToRemove);
    return true;
  }

  // ------------ Visual grouping ------------

  function ungroupAllHeads() {
    document.querySelectorAll('[data-bundle-tail]').forEach((el) => {
      el.removeAttribute('data-bundle-tail');
      el.style.display = '';
    });
    document.querySelectorAll('[data-bundle-head]').forEach((el) => {
      const snap = el.__discoveryByoSnapshot;
      if (snap) {
        el.innerHTML = snap;
        delete el.__discoveryByoSnapshot;
      }
      el.removeAttribute('data-bundle-head');
    });
  }

  function rewriteHead(headEl, groupEntries, headIsBox) {
    headEl.__discoveryByoSnapshot = headEl.innerHTML;
    headEl.setAttribute('data-bundle-head', '1');

    const sampleEntries = groupEntries.filter((e) => !isBoxItem(e.item));
    const dufte = sampleEntries.map(({ item }) => {
      const name = (item.properties.Duft || item.product_title || '')
        .replace(/^LYORA Duftprobe\s*/i, '')
        .trim();
      return item.quantity > 1 ? item.quantity + '× ' + name : name;
    });

    const titleEl = headEl.querySelector('.cart-item__title');
    if (titleEl && !headIsBox) {
      titleEl.textContent = 'LYORA Discovery Set';
      if (titleEl.tagName === 'A') titleEl.setAttribute('href', BUNDLE_PARENT_URL);
    }

    // The box line already carries its own image, title and price – only a
    // legacy sample head needs to be dressed up as the set.
    if (bundleImageUrl && !headIsBox) {
      const imgs = headEl.querySelectorAll('.cart-item__media img, .cart-item__media source');
      imgs.forEach((node) => {
        if (node.tagName === 'IMG') {
          node.setAttribute('src', bundleImageUrl);
          node.removeAttribute('srcset');
          node.setAttribute('alt', 'LYORA Discovery Set');
        } else {
          node.setAttribute('srcset', bundleImageUrl);
        }
      });
      const mediaLink = headEl.querySelector('.cart-item__media');
      if (mediaLink && mediaLink.tagName === 'A') {
        mediaLink.setAttribute('href', BUNDLE_PARENT_URL);
        mediaLink.setAttribute('aria-label', 'LYORA Discovery Set');
      }
    }

    const dufteHtml =
      '<div class="cart-item__bundle-list" style="font-size:12px;color:#888;line-height:1.7;margin-top:2px;">' +
      dufte.map((d) => '· ' + d).join('<br>') +
      '</div>';
    const optsEl = headEl.querySelector('.cart-item__options');
    if (optsEl) {
      optsEl.innerHTML = dufteHtml;
    } else {
      const detailsEl =
        headEl.querySelector('.cart-item__details .grid') ||
        headEl.querySelector('.cart-item__details');
      if (detailsEl && titleEl) {
        const wrapper = document.createElement('div');
        wrapper.className = 'cart-item__options cart-item__bundle-list-wrapper';
        wrapper.innerHTML = dufteHtml;
        titleEl.parentElement.parentElement.insertBefore(wrapper, titleEl.parentElement.nextSibling);
      }
    }

    const pricesEl = headEl.querySelector('.cart-item__prices');
    if (pricesEl && !headIsBox) {
      pricesEl.innerHTML =
        '<div class="price font-body-bolder"><span class="f-price__regular">' +
        BUNDLE_PRICE_DISPLAY +
        '</span></div>';
    }

    const discountsEl = headEl.querySelector('.cart-item__discounts');
    if (discountsEl) discountsEl.style.display = 'none';

    // Bundle is atomic — hide the quantity stepper entirely. Showing the
    // head line's component quantity (e.g. "2× Pathos" → 2) misrepresents
    // the set count.
    headEl.querySelectorAll('quantity-input, .cart-quantity, .cart-item__quantity').forEach((q) => {
      q.style.display = 'none';
    });

    const removeBtn = headEl.querySelector('.cart-item__remove');
    if (removeBtn) {
      const newBtn = removeBtn.cloneNode(true);
      removeBtn.parentNode.replaceChild(newBtn, removeBtn);
      newBtn.setAttribute('href', '#');
      newBtn.addEventListener('click', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        await removeItems(groupEntries.map((entry) => entry.item));
      });
    }
  }

  function groupBundleLines(cart) {
    const entries = getBundleEntries(cart);
    if (entries.length === 0) return;
    const buckets = bucketByGroup(entries);

    for (const groupEntries of buckets.values()) {
      const shape = groupShape(groupEntries);
      // Only single sets are collapsed; incomplete groups are wiped by the
      // cleanup, multi-set groups are left as they are.
      if (!shape.complete) continue;
      if (shape.boxQty > 1 || (shape.boxQty === 0 && shape.sampleQty !== BUNDLE_SIZE)) continue;

      const withEls = groupEntries
        .map((e) => ({ ...e, el: findCartItemElement(e.index) }))
        .filter((x) => x.el);
      if (withEls.length === 0) continue;

      const boxEntry = withEls.find((x) => isBoxItem(x.item));
      const head = boxEntry || withEls[0];
      const tails = withEls.filter((x) => x !== head);
      if (head.el.getAttribute('data-bundle-head') === '1') continue;

      tails.forEach((t) => {
        t.el.setAttribute('data-bundle-tail', '1');
        t.el.style.display = 'none';
      });

      rewriteHead(head.el, groupEntries, !!boxEntry);
    }
  }

  // ------------ Wiring ------------

  async function onCartUpdate(payload) {
    if (isCleaning) return;
    const cart = (payload && payload.cart) || (await fetchCart());
    const cleaned = await cleanupOrphans(cart);
    if (cleaned) return;
    ungroupAllHeads();
    requestAnimationFrame(() => groupBundleLines(cart));
  }

  function init() {
    if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, onCartUpdate);
      fetchBundleParentImage();
      fetchCart().then((cart) => onCartUpdate({ cart }));
    } else {
      setTimeout(init, 100);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
